export const DataTypesOfAddress = [
    {
        phoneTypeText: 'RESIDENCIAL',
        phoneTypeId: 1
    },
    {
        phoneTypeText: 'COMERCIAL',
        phoneTypeId: 2
    },
    {
        phoneTypeText: 'FATURAMENTO',
        phoneTypeId: 3
    },
    {
        phoneTypeText: 'ENTREGA',
        phoneTypeId: 4
    },
    {
        phoneTypeText: 'INSTALAÇÃO',
        phoneTypeId: 5
    },
    {
        phoneTypeText: 'CORRESPONDÊNCIA',
        phoneTypeId: 6
    },
    {
        phoneTypeText: 'REMESSA',
        phoneTypeId: 8
    }
];
